// /* eslint-disable import/no-anonymous-default-export */
import React from 'react';

import { EmployeePensionContext } from './context/EmployeePensionContext';

const useEmployeePensionContext = () => React.useContext(EmployeePensionContext);
export default useEmployeePensionContext;
